import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const DocumentsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Documents",
    children: /*#__PURE__*/_jsx("path", {
      d: "M20.67 8.07a.47.47 0 0 0-.47-.47H5.27a.47.47 0 0 0-.47.47v9.33c0 .26.21.47.47.47.77 0 1.4.63 1.4 1.4s-.63 1.4-1.4 1.4C3.47 20.67 2 19.21 2 17.4V8.07C2 6.27 3.46 4.8 5.27 4.8H20.2c1.8 0 3.27 1.46 3.27 3.27 0 .77-.63 1.4-1.4 1.4s-1.4-.63-1.4-1.4m6.07 3.27H11.81c-1.8 0-3.27 1.46-3.27 3.27v9.33c0 1.8 1.46 3.27 3.27 3.27h14.93c1.8 0 3.27-1.46 3.27-3.27v-9.33c0-1.8-1.46-3.27-3.27-3.27m-.93 12.6H12.74c-.52 0-.93-.42-.93-.93s.42-.93.93-.93h13.07c.52 0 .93.42.93.93s-.42.93-.93.93m0-3.73H12.74c-.52 0-.93-.42-.93-.93s.42-.93.93-.93h13.07c.52 0 .93.42.93.93s-.42.93-.93.93m0-3.73H12.74c-.52 0-.93-.42-.93-.93s.42-.93.93-.93h13.07c.52 0 .93.42.93.93s-.42.93-.93.93"
    })
  }));
};